import React, {useEffect, useState} from "react";
import EnigooButton from "../../EnigooButton";
import { FiFile, FiHelpCircle, FiX } from "react-icons/fi";
import { Field } from "react-final-form";
import { useFilePicker } from "use-file-picker";
import { useTranslation } from "react-i18next";
import EnigooToolTip from "../../EnigooToolTip";
import CogoToast from "cogo-toast";

const ImageCustomField = ({ label, name, toolTip, toolTipPosition = "right", onClear }) => {
    const { t } = useTranslation();

    const [openFileSelector, { filesContent, clear, plainFiles }] = useFilePicker({
        accept: [".png", ".jpg", ".jpeg", ".gif"],
        readAs: "DataURL",
        multiple: false,
        limitFilesConfig: { max: 1},
    });

    const handleClear = (input) => {
        clear();
        input.onChange(null);
        if (onClear) onClear();
    };

    const isValidImage = (value) =>
        !!value && (value.startsWith("data:") || value.startsWith("http"));

    const renderPreviewImage = (input) => (
        <div className="flex flex-col space-y-2">
            <img
                className="max-h-sm object-contain rounded border border-grey-300"
                src={input.value || ""}
                alt="preview"
            />
            <EnigooButton
                onClick={() => handleClear(input)}
                icon={<FiX />}
                color="red"
                text={t("photo.clearSelection")}
            />
        </div>
    );

    return (
        <Field name={name}>
            {({ input, meta }) => {
                // useEffect mimo render prop → přesunut níže
                return (
                    <ImageFieldContent
                        input={input}
                        meta={meta}
                        filesContent={filesContent}
                        openFileSelector={openFileSelector}
                        handleClear={handleClear}
                        renderPreviewImage={renderPreviewImage}
                        isValidImage={isValidImage}
                        label={label}
                        toolTip={toolTip}
                        toolTipPosition={toolTipPosition}
                        plainFiles={plainFiles}
                    />
                );
            }}
        </Field>
    );
};

const ImageFieldContent = ({
                               input,
                               meta,
                               filesContent,
                               openFileSelector,
                               handleClear,
                               renderPreviewImage,
                               isValidImage,
                               label,
                               toolTip,
                               toolTipPosition,
                                plainFiles
                           }) => {
    const { t } = useTranslation();

    let [sizeError, setSizeError] = useState(null);
    const MAX_FILE_SIZE_BYTES = 2 * 1024 * 1024;
    const hasUserSelectedFile = plainFiles && plainFiles.length > 0
    // Hook voláme přímo ve funkční komponentě
    useEffect(() => {
        setSizeError(null);
        if(!hasUserSelectedFile) return;
        const file = plainFiles[0]; // Původní objekt souboru zde je size

        // KONTROLA VELIKOSTI
        if (file.size > MAX_FILE_SIZE_BYTES) {
            CogoToast.error(t("photo.chooseToolTipOnline"));
            input.onChange(null); // Nastavit hodnotu na NULL
            return;
        }

        // Soubor je platný, nastavit DataURL (to se dělo dříve)
        input.onChange(filesContent[0].content);
    }, [filesContent, plainFiles, input.onChange]);

    return (
        <div className="form-element">
            <div className="form-label flex items-center">
                {label}
                {toolTip && (
                    <>
                        <FiHelpCircle
                            data-tip
                            data-for={`_tooltip_${label}`}
                            className="ml-2 text-red-900"
                            size={18}
                        />
                        <EnigooToolTip
                            content={toolTip}
                            id={`_tooltip_${label}`}
                            place={toolTipPosition}
                        />
                    </>
                )}
            </div>

            {isValidImage(input.value) ? (
                renderPreviewImage(input)
            ) : (
                <EnigooButton
                    onClick={() => openFileSelector()}
                    text={t("photo.chooseImage")}
                    icon={<FiFile />}
                />
            )}

            {meta.error && meta.touched && (
                <div className="form-error">{meta.error}</div>
            )}
        </div>
    );
};

export default ImageCustomField;
